import { createElement } from "react";
import { PROFILE_PATH } from "@routes/path";
import type { AppRoute } from "@routes/types";
import ProfilePage from "@pages/profile";
import AppShellLayout from "@components/ui/layout/AppShellLayout";
import type { RouteObject } from "react-router-dom";
import { RoleProtectedRoute } from "@components/ui/layout/RoleProtectedRoute";

const routes: AppRoute[] = [
    {
        path: PROFILE_PATH,
        element: createElement(ProfilePage),
        label: "Profile",
    }
];

const ProfileRoute: RouteObject[] = [{
    element: createElement(RoleProtectedRoute, { requiredRoles: ["recruiter"] }),
    children: [
        {
            element: createElement(AppShellLayout),
            children: routes
        }
    ]
}];

export default ProfileRoute;